const productCardProductCache = new Map();

function generateSrcset(image, widths = []) {
  const imageUrl = new URL(image.src);
  return widths
    .filter((width) => width <= image.width)
    .map((width) => {
      imageUrl.searchParams.set('width', width.toString());
      return `${imageUrl.href} ${width}w`;
    })
    .join(', ');
}

function createImageElement(image, classes, sizes, productTitle) {
  const previewImage = image.preview_image;
  const newImage = new Image(previewImage.width, previewImage.height);
  newImage.className = classes;
  newImage.alt = image.alt || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage.src;
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading = 'lazy';
  return newImage;
}

function getCardProduct(productHandle) {
  if (!productCardProductCache.has(productHandle)) {
    productCardProductCache.set(
      productHandle,
      jQuery.getJSON(`${window.Shopify.routes.root}products/${productHandle}.js`)
    );
  }
  return productCardProductCache.get(productHandle);
}

function getVariantIdFromLink(variantLink) {
  if (!variantLink) return null;
  try {
    return new URL(variantLink, window.location.origin).searchParams.get('variant');
  } catch (error) {
    const match = variantLink.match(/[?&]variant=(\d+)/);
    return match ? match[1] : null;
  }
}

function updateCardImage(wrapper, input) {
  const primaryImage = wrapper.querySelector('.media--first');
  const secondaryImage = wrapper.querySelector('.media--second');
  const productHandle = wrapper.dataset.product;
  const variantLink = input.dataset.variantLink || '';
  const variantId = getVariantIdFromLink(variantLink);

  if (!primaryImage || !productHandle || !variantId) return;

  const productLink = wrapper.querySelector('.js-color-swatches-link');
  if (productLink) productLink.href = variantLink;

  getCardProduct(productHandle).done((product) => {
    const variant = product.variants.find(
      (item) => String(item.id) === String(variantId)
    );

    if (!variant || !variant.featured_media) return;

    const newPrimaryImage = createImageElement(
      variant.featured_media,
      primaryImage.className,
      primaryImage.sizes,
      product.title
    );

    if (
      new URL(newPrimaryImage.src).pathname ===
      new URL(primaryImage.src).pathname
    ) return;

    if (secondaryImage) {
      const secondaryPath = new URL(secondaryImage.src).pathname;
      const newPrimaryPath = new URL(newPrimaryImage.src).pathname;
      if (secondaryPath === newPrimaryPath) {
        primaryImage.remove();
        secondaryImage.classList.remove('media--second');
        secondaryImage.classList.add('media--first');
        return;
      }
    }

    primaryImage.animate(
      { opacity: [1, 0] },
      { duration: 180, easing: 'ease-in', fill: 'forwards' }
    ).finished;

    window.setTimeout(() => {
      const currentPrimary = wrapper.querySelector('.media--first');
      if (!currentPrimary) return;
      currentPrimary.replaceWith(newPrimaryImage);
      newPrimaryImage.animate(
        { opacity: [0, 1] },
        { duration: 180, easing: 'ease-in' }
      );
      const currentSecondary = wrapper.querySelector('.media--second');
      if (currentSecondary) currentSecondary.remove();
    }, 180);
  });
}

function getSwatchData(target) {
  const label = target.closest('label.color-swatch');
  if (!label) return null;

  const input = document.getElementById(label.htmlFor);
  const wrapper = label.closest('.js-color-swatches-wrapper');
  if (!input || !wrapper || input.disabled) return null;

  return { label, input, wrapper };
}

(function initialiseCollectionSwatches() {
  if (window.adylooCollectionSwatchesInitialised) return;
  window.adylooCollectionSwatchesInitialised = true;

  /* Hover: ohne pointerType-Prüfung, damit Desktop-Browser zuverlässig reagieren. */
  document.addEventListener('mouseover', (event) => {
    const data = getSwatchData(event.target);
    if (!data || data.input.checked) return;
    data.input.checked = true;
    updateCardImage(data.wrapper, data.input);
  });

  /* Klick: auch bei dynamisch nachgeladenen Produktkarten zuverlässig ausführen. */
  document.addEventListener('click', (event) => {
    const data = getSwatchData(event.target);
    if (!data) return;
    data.input.checked = true;
    updateCardImage(data.wrapper, data.input);
  });

  document.addEventListener('shopify:section:load', () => {
    /* Delegierte Events gelten automatisch auch für neu geladene Karten. */
  });
})();
